import AxiosInstance from './AxiosInstance';

export const fetchData = async (API_URL) => {
    try {
        const response = await AxiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

